import { render, staticRenderFns } from "./ChartLegends.vue?vue&type=template&id=dd308152&scoped=true&"
import script from "./ChartLegends.vue?vue&type=script&lang=js&"
export * from "./ChartLegends.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegends.vue?vue&type=style&index=0&id=dd308152&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd308152",
  null
  
)

export default component.exports